// eslint-disable-next-line import/no-unresolved
module.exports = require('./lib');



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-dates/index.js
// module id = 506
// module chunks = 0